<template>
  <div>
    <v-tooltip v-for="indicator in items" v-bind:key="indicator.id" top>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" :color="indicator.color" small class="mr-2">
          {{ indicator.icon }}
        </v-icon>
      </template>
      <span> {{ indicator.tooltip }} </span>
    </v-tooltip>

    <span v-if="items.length === 0" class="font-italic text--disabled">
      {{ $t('misc.none') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TimePairStatusIndicator',

  props: {
    items: Array,
  },
};
</script>
